import { State } from './types';

export const isFavouriteSelector = (state: State, companyKey: number): boolean =>
  !!state.companies.find(company => company.companyKey === companyKey);
